export default __webpack_public_path__ + "static/23-96bece5630dc58801afceec2c9a9b4a0.jpg";